// Chat is disabled on web — available on mobile app only
// Original code backed up to $roomid.tsx.bak

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/vendor/chat/$roomid")({
	loader: () => {
		throw redirect({ to: "/download" });
	},
	component: () => null
});
